module.exports = __webpack_public_path__ + "static/media/kmart_flat_masterbrand_rgb.e27b4fd9.png";